export default __webpack_public_path__ + "static/media/Attendance.2cbd2e22.png";